import React from 'react';
import Header from '../../layout/Header'
import MobileNav from '../../layout/MobileNav'
import { useSelector, useDispatch } from 'react-redux';
import { fetchSavedSpotsDailyForecast } from '../../store/slices/daylyForecastSlice'
import { fetchAllSpots } from '../../store/slices/savedSpotsSlice';
import DailyForecastDataTable from '../../components/open-meteo/daily/DailyForecastDataTable';
import ViewLink from '../../components/buttons/ViewLink';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom'

const SpotsForecast = () => {
    
    const dispatch = useDispatch();
    // const spots = useSelector((state) => state.savedLocations.spots);
    const savedSpots = useSelector((state) => state.savedSpots.spots);
    const savedSpotsDailyForecast = useSelector((state) => state.dailyForecast.spots);
    const visibleUnits = useSelector((state) => state.dailyForecast.visibleUnitsDaily) || {
        wave_height_max: true,
        wave_direction_dominant: false,
        wave_period_max: false,
        wind_speed_10m_max: true,
        wind_direction_10m_dominant: false,
        overall_rating_score: true
    };

    React.useEffect(() => {
        // Dispatch action to fetch all spots' forecast data
        dispatch(fetchSavedSpotsDailyForecast());
        dispatch(fetchAllSpots());
    }, [dispatch]);

    const renderSpots = () => {

        return Object.values(savedSpots).map((spot) => (
            <div key={spot.id}>
                <div className="flex items-center justify-between mb-2">
                    <div>
                        <h2 className='text-lg font-semibold'>{spot.name}</h2>
                        <div className='text-xs text-custom-light-grey'>{Number(spot.latitude).toFixed(2)}, {Number(spot.longitude).toFixed(2)}</div>
                    </div>
                    <ViewLink to={spot.id}>View →</ViewLink>
                </div>
                <DailyForecastDataTable forecastData={savedSpotsDailyForecast[spot.id]} visibleUnits={visibleUnits} spot={spot} />
            </div>
        ));
    }    

    return(
        <>
            <Helmet>
                <title>My Spots Forecast | Oreca Pro</title>
                <link rel="canonical" href={window.location.href} />
            </Helmet>
            <Header />
            <MobileNav />
            <div className='py-[80px] px-5 max-w-[1100px] mx-auto'>
                <h1 className='text-2xl font-semibold mb-2 md:mt-8'>My Spots</h1>
                <p className='text-custom-light-grey mt-10'>
                    Your daily forecast, ratings according to your ideal conditions, and selectable units for all your ocean sport spots. <Link to="/options" className='text-custom-light-blue'>click here to add or remove units</Link>.
                </p>
                <div className='mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5'>
                    {renderSpots()}
                </div>
            </div>
        </>
    )
}

export default SpotsForecast
